import { Item, ItemId } from '../types';

export const ITEMS: Record<ItemId, Item> = {
  staffroom_key: {
    id: 'staffroom_key',
    name: '職員室の鍵',
    description: '古びた鍵。「職員室」と刻まれている。',
    icon: '🔑',
    isKeyItem: true,
  },
  diary_fragment_1: {
    id: 'diary_fragment_1',
    name: '日記の断片 1',
    description: '破れた日記のページ。「…また今日も無視された…」と書かれている。',
    icon: '📄',
    isKeyItem: false,
  },
  diary_fragment_2: {
    id: 'diary_fragment_2',
    name: '日記の断片 2',
    description: '「…あの人だけは気づいてくれると思っていた…」',
    icon: '📄',
    isKeyItem: false,
  },
  diary_fragment_3: {
    id: 'diary_fragment_3',
    name: '日記の断片 3',
    description: '「…廊下で目が合った。でも、すぐにそらされた…」',
    icon: '📄',
    isKeyItem: false,
  },
  diary_fragment_4: {
    id: 'diary_fragment_4',
    name: '日記の断片 4',
    description: '「…もう誰も信じられない。この学校にいる意味がわからない…」',
    icon: '📄',
    isKeyItem: false,
  },
  diary_fragment_5: {
    id: 'diary_fragment_5',
    name: '日記の断片 5',
    description: '「…最後に屋上から空を見たい。きっと綺麗だから…」',
    icon: '📄',
    isKeyItem: false,
  },
  music_room_key: {
    id: 'music_room_key',
    name: '音楽室の鍵',
    description: '音符の形をしたキーホルダーがついた鍵。',
    icon: '🗝️',
    isKeyItem: true,
  },
  student_roster: {
    id: 'student_roster',
    name: '生徒名簿',
    description: '2年B組の生徒名簿。「水無月 詩織」の名前に赤線が引かれている。',
    icon: '📋',
    isKeyItem: false,
  },
  medicine_bottle: {
    id: 'medicine_bottle',
    name: '薬瓶',
    description: '空の薬瓶。ラベルには「安定剤」と書かれている。',
    icon: '🫙',
    isKeyItem: false,
  },
  torn_sheet_music_1: {
    id: 'torn_sheet_music_1',
    name: '破れた楽譜 1/3',
    description: '楽譜の左部分。最初の3音が読み取れる。\n\n♪ ド → ミ → ソ → ……\n\n続きは別の断片にあるようだ。',
    icon: '🎵',
    isKeyItem: false,
  },
  torn_sheet_music_2: {
    id: 'torn_sheet_music_2',
    name: '破れた楽譜 2/3',
    description: '楽譜の中央部分。3音が読み取れる。\n\n♪ …… → ド → ミ → ソ → ……\n\n前後が破れて欠けている。',
    icon: '🎵',
    isKeyItem: false,
  },
  torn_sheet_music_3: {
    id: 'torn_sheet_music_3',
    name: '破れた楽譜 3/3',
    description: '楽譜の右部分。最後の3音が読み取れる。\n\n♪ …… → ラ → シ → ド\n\nこれで楽譜が完成するはずだ。',
    icon: '🎵',
    isKeyItem: false,
  },
  floor3_key: {
    id: 'floor3_key',
    name: '3階の鍵',
    description: '3階への階段の施錠を解除する鍵。',
    icon: '🔑',
    isKeyItem: true,
  },
  rooftop_key: {
    id: 'rooftop_key',
    name: '屋上の鍵',
    description: '重厚な鍵。持つと微かに冷たい。',
    icon: '🗝️',
    isKeyItem: true,
  },
  shiori_letter: {
    id: 'shiori_letter',
    name: '詩織の手紙',
    description: '丁寧な字で書かれた手紙。宛名は……あなたの名前だ。\n\n「あなたへ\n\n恨んでいると思った？\n少しだけ、恨んでいた。\nでも、もう疲れた。\n\n私が本当に欲しかったのは、\nたった一言の「大丈夫？」だった。\n\nもう遅いけれど、\nもしあなたが本当に後悔しているなら、\n一つだけ聞かせて。\n\nあなたは今、何を思っている？」',
    icon: '✉️',
    isKeyItem: true,
  },
  morse_chart: {
    id: 'morse_chart',
    name: 'モールス信号変換表',
    description: '50音とモールス信号の対応表が印刷された紙。\n授業で使われていたもののようだ。',
    icon: '📜',
    isKeyItem: false,
  },
  old_photograph: {
    id: 'old_photograph',
    name: '古い写真',
    description: 'クラスの集合写真。笑顔の中、一人だけ俯いている少女がいる。',
    icon: '/images/写真.jpg',
    isKeyItem: false,
  },
};
